import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import StoreIcon from "@mui/icons-material/Store";
import axios from "axios";
import Header from "./Header";

const ShopInService = () => {
  const [shops, setShops] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    axios
      .get("https://sakhisshop.com/api/shops")
      .then((res) => setShops(res.data))
      .catch((err) => console.error("Failed to fetch shops", err));
  }, []);

  const visibleShops = showAll ? shops : shops.slice(0, 4);

  return (
    <Container sx={{ mt: 5, mb: 5, py: 3 }}>
      <Header />
      <Box textAlign="center" mb={4}>
        <StoreIcon fontSize="large" color="primary" />
        <Typography variant="h4" fontWeight={600}>
          🛒 Shops In Service
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" mt={1}>
          Explore available shops in your area.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {shops.length === 0 ? (
          <Typography variant="h6" sx={{ mx: "auto" }} color="error">
            No shops available.
          </Typography>
        ) : (
          visibleShops.map((shop, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ boxShadow: 4, borderRadius: 3 }}>
                <CardMedia
                  component="img"
                  height="180"
                  image={
                    shop.photo && shop.photo !== "null"
                      ? shop.photo
                      : "https://via.placeholder.com/300x180?text=No+Image"
                  }
                  alt={shop.shopname}
                  style={{ objectFit: "cover" }}
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    textAlign="center"
                    sx={{ fontFamily: "Poppins", fontWeight: 600 }}
                  >
                    {shop.shopname}
                  </Typography>
                  <Typography
                    variant="body2"
                    textAlign="center"
                    color="text.secondary"
                  >
                    📍 {shop.area}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>

      {/* Show toggle button only if more than 4 shops */}
      {shops.length > 4 && (
        <Box mt={4} textAlign="center">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less" : "View All Shops"}
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default ShopInService;
